export default class dialogPage {
    constructor(pageName, data) {
        this.pageName = pageName ? pageName : '';
        this.data = data ? data : {};
    }
}